/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CnyWalletBillItem } from './CnyWalletBillItem';
import {
    CnyWalletBillItemFromJSON,
    CnyWalletBillItemFromJSONTyped,
    CnyWalletBillItemToJSON,
    CnyWalletBillItemToJSONTyped,
} from './CnyWalletBillItem';
import type { EnumItem3 } from './EnumItem3';
import {
    EnumItem3FromJSON,
    EnumItem3FromJSONTyped,
    EnumItem3ToJSON,
    EnumItem3ToJSONTyped,
} from './EnumItem3';

/**
 * 
 * @export
 * @interface CnyWalletBillListVo
 */
export interface CnyWalletBillListVo {
    /**
     * 当前页
     * @type {number}
     * @memberof CnyWalletBillListVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof CnyWalletBillListVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof CnyWalletBillListVo
     */
    totalRecord?: number;
    /**
     * 账单记录列表
     * @type {Array<CnyWalletBillItem>}
     * @memberof CnyWalletBillListVo
     */
    records?: Array<CnyWalletBillItem>;
    /**
     * 账单状态列表
     * @type {Array<EnumItem3>}
     * @memberof CnyWalletBillListVo
     */
    statusList?: Array<EnumItem3>;
}

/**
 * Check if a given object implements the CnyWalletBillListVo interface.
 */
export function instanceOfCnyWalletBillListVo(value: object): value is CnyWalletBillListVo {
    return true;
}

export function CnyWalletBillListVoFromJSON(json: any): CnyWalletBillListVo {
    return CnyWalletBillListVoFromJSONTyped(json, false);
}

export function CnyWalletBillListVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CnyWalletBillListVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(CnyWalletBillItemFromJSON)),
        'statusList': json['statusList'] == null ? undefined : ((json['statusList'] as Array<any>).map(EnumItem3FromJSON)),
    };
}

export function CnyWalletBillListVoToJSON(json: any): CnyWalletBillListVo {
    return CnyWalletBillListVoToJSONTyped(json, false);
}

export function CnyWalletBillListVoToJSONTyped(value?: CnyWalletBillListVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(CnyWalletBillItemToJSON)),
        'statusList': value['statusList'] == null ? undefined : ((value['statusList'] as Array<any>).map(EnumItem3ToJSON)),
    };
}

